import { render, staticRenderFns } from "./Xc.vue?vue&type=template&id=16dc6e37&"
import script from "./Xc.vue?vue&type=script&lang=js&"
export * from "./Xc.vue?vue&type=script&lang=js&"
import style0 from "./Xc.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports